const INITIAL_STATE = {
    estados: [],
    estado: {}
}

export default function Estado(state = INITIAL_STATE, action) {
    switch(action.type) {
        case 'ESTADOS_FETCHED' :
            return { ...state, estados: action.payload }
        case 'ESTADO_FETCHED' :
            return { ...state, estado: action.payload }
        default :
            return state
    }
}